<template>
  <component
    :is="isLink ? TheNuxtLink : 'div'"
    v-bind="isLink ? linkProps : {}"
    :class="contextClassName"
    class="relative flex min-h-[140px] flex-wrap overflow-hidden rounded bg-white shadow-normal shadow-gray-400 tablet:block tablet:h-full tablet:min-h-0"
  >
    <figure
      v-if="imageUrl"
      class="relative h-[140px] w-[140px] overflow-hidden bg-black tablet:aspect-video tablet:h-auto tablet:w-full"
    >
      <img
        :src="imageUrl"
        :alt="title"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </figure>
    <div
      class="w-[calc(100%-140px)] p-3 tablet:w-full tablet:px-5 tablet:pb-5 tablet:pt-2"
    >
      <span v-if="caption" class="block text-xs text-gray-600">
        {{ caption }}
      </span>
      <strong
        v-if="title"
        class="line-clamp-2 max-h-14 text-lg font-bold tablet:mb-5"
      >
        {{ title }}
      </strong>
      <TheArrowLink
        v-if="!isClickCard && !isMobile"
        :id="buttonId"
        :to="isLinkDisable ? undefined : to"
        :title="buttonName"
        :disabled="isLinkDisable"
      >
        {{ buttonName }}
      </TheArrowLink>
    </div>
  </component>
</template>

<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  import type { NuxtLinkProps } from '#app';
  interface IProps extends NuxtLinkProps {
    to?: RouteLocationRaw;
    title: string;
    caption: string;
    imageUrl: string;
    buttonName: string;
    buttonId?: string;
    isLinkDisable?: boolean;
    isClickCard?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    to: undefined,
    buttonId: '',
    isLinkDisable: false,
    isClickCard: true,
  });

  const TheNuxtLink = resolveComponent('TheNuxtLink');

  const { isMobile } = useScreen();

  const isLink = computed((): boolean => {
    const shouldBeLink = props.isClickCard || isMobile.value;
    return shouldBeLink && props.to !== undefined;
  });

  const linkProps = computed((): NuxtLinkProps => {
    const {
      title,
      caption,
      imageUrl,
      buttonName,
      buttonId,
      isLinkDisable,
      isClickCard,
      ...nuxtLinkProps
    } = props;

    return {
      ...nuxtLinkProps,
      ...(isClickCard && { title }),
    };
  });

  const contextClassName = computed((): string => {
    if (props.isClickCard) {
      return 'cursor-pointer tablet:border tablet:border-solid tablet:border-white tablet:hover:border-blue-400';
    }
    return '';
  });
</script>
